/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

import HeaderDark from "../../../common/header/HeaderDark";
import FooterOne from "../../../common/footer/FooterOne";

import banner from "../../../../src/app/assets/images/marketing-media/marketing.mp4";

// brand logo imports

import c1 from "../../../app/assets/images/banner/c1.jpg";
import c2 from "../../../app/assets/images/banner/c2.jpg";
import c3 from "../../../app/assets/images/banner/c3.jpg";
import c4 from "../../../app/assets/images/banner/c4.jpg";
import c5 from "../../../app/assets/images/banner/c5.jpg";
import c6 from "../../../app/assets/images/banner/c6.jpg";
import c7 from "../../../app/assets/images/banner/c7.jpg";
import c8 from "../../../app/assets/images/banner/c8.jpg";
import c9 from "../../../app/assets/images/banner/c9.jpg";
import c10 from "../../../app/assets/images/banner/c10.jpg";
import c11 from "../../../app/assets/images/banner/c11.jpg";
import c12 from "../../../app/assets/images/banner/c12.jpg";
import c13 from "../../../app/assets/images/banner/c13.jpg";
import c14 from "../../../app/assets/images/banner/c14.jpg";
import c15 from "../../../app/assets/images/banner/c15.jpg";
import c16 from "../../../app/assets/images/banner/c16.jpg";
import c17 from "../../../app/assets/images/banner/c17.jpg";
import c19 from "../../../app/assets/images/banner/c19.jpg";
import c20 from "../../../app/assets/images/banner/c20.jpg";
import c21 from "../../../app/assets/images/banner/c21.png";
import c22 from "../../../app/assets/images/banner/c22.png";
import c23 from "../../../app/assets/images/banner/c23.png";
import c24 from "../../../app/assets/images/banner/c24.png";
import c25 from "../../../app/assets/images/banner/c25.png";
import c26 from "../../../app/assets/images/banner/c26.png";
import c27 from "../../../app/assets/images/banner/c27.png";
import c28 from "../../../app/assets/images/banner/c28.png";
import c29 from "../../../app/assets/images/banner/c29.png";
import c30 from "../../../app/assets/images/banner/c30.png";
import c31 from "../../../app/assets/images/banner/c31.png";

// Cutout imports

import cutout1 from "../../../app/assets/images/marketing-media/cutout1.jpg";
import cutout2 from "../../../app/assets/images/marketing-media/cutout2.jpg";

// icons import

import icon1 from "../../../app/assets/images/marketing-media/icon1.png";
import icon2 from "../../../app/assets/images/marketing-media/icon2.png";
import icon3 from "../../../app/assets/images/marketing-media/icon3.png";
import icon4 from "../../../app/assets/images/marketing-media/icon4.png";
import icon5 from "../../../app/assets/images/marketing-media/icon5.png";
import icon6 from "../../../app/assets/images/marketing-media/icon6.png";
import icon7 from "../../../app/assets/images/marketing-media/icon7.png";

const Products = () => {

const properties = {
prevArrow: (
<button className="cs-btn btn-left">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left"
    viewBox="0 0 16 16">
    <path fill-rule="evenodd"
      d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
  </svg>
</button>
),
nextArrow: (
<button className="cs-btn btn-right">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right"
    viewBox="0 0 16 16">
    <path fill-rule="evenodd"
      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
  </svg>
</button>
),
};
return (

<div className="marketing-page">
  <HeaderDark />
  <section
    class="d-flex align-items-center justify-content-center banner-sec marketing-sec text-center text-lg-start margin-minus">
    <div class="container custom-cn-width position-relative z-index-1">
      <div class="row align-items-center justify-content-center justify-content-lg-start g-lg-5 g-4">
        <div class="col-lg-9 mb-4 pe-lg-5">
          <h2>Marketing Consulting that targets your prospects and boosts engagement</h2>
        </div>
      </div>
      <div class="row align-items-center g-4 justify-content-center justify-content-lg-between">
        <div class="col-xl-5 col-lg-6 col-md-9 pe-lg-5">
          <p class="text-dark">Marketing all comes down to <b class="fw-bold">getting your message out to your
              customers and prospects</b> and <b class="fw-bold">convincing them to engage</b> with you, but
            implementing a successful marketing strategy requires the investment of a lot of time and resources.
          </p>
          <p class="text-dark mt-3">Marketing is a <b class="fw-bold">highly complex, constantly evolving
              process</b> with a lot of moving parts, but CAP Digisoft’s Marketing Consulting team excels at
            building <b class="fw-bold">custom, strategic marketing plans </b> that include success metrics
            aligned to business goals, timetables, target buyer personas, custom content, performance analytics,
            and more – all resulting in increase ROI.</p>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-9">
          <div class="video-block">
            <div class="video-objec">
              <video class="w-100 b-r-6" loop="true" autoplay="true" muted="">
                <source src={banner} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="position-relative z-index-10 bg-white section-padding">
    <div class="container custom-cn-width">
      <div class="row g-xl-5 g-4 justify-content-center">
        <div class="col-lg-12 col-md-9 mb-lg-5 mb-4 text-center">
          <h1 class="fw-light">How can Marketing Consulting help your business?</h1>
        </div>
      </div>
      <div class="row g-lg-5 g-4 justify-content-center text-center text-lg-start">
        <div class="col-xl-4 col-md-8 order-lg-1 col-lg-6">
          <div class="row g-xl-5 g-4 justify-content-center">
            <div class="col-12 d-lg-flex align-items-start">
              <div class="me-xl-4 me-lg-3">
                <div
                  class="icons sec-primary-ic mb-4 d-flex align-items-center justify-content-center mx-auto rounded-pill">
                  <img src={icon1} class="img-fluid" alt="Over a decade of experience" /></div>
              </div>
              <div>
                <p>CAP Digisoft has <b class="fw-bold">over a decade of experience</b> with inbound and
                  outbound marketing and our team are <b class="fw-bold">experts in the tools and
                    technology</b> that will improve your effectiveness and deliver results, for a price
                  that won’t break your budget.</p>
              </div>
            </div>
            <div class="col-12 d-lg-flex align-items-start">
              <div class="me-xl-4 me-lg-3">
                <div
                  class="icons mb-4 d-flex align-items-center justify-content-center mx-auto sec-primary-ic rounded-pill">
                  <img src={icon3} class="img-fluid" alt="Over a decade of experience" /></div>
              </div>
              <div>
                <p>CAP Digisoft <b class="fw-bold">continually re-engages your prospects</b> across a
                  variety of different channels to make sure your business is continually top-of-mind with
                  your targets. We use retargeting banner ads, social media, email, text message and more.
                  We <b class="fw-bold">stay in front of your prospect</b> to make it easy for them to
                  connect with your business when they need your services.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-8 order-lg-2 order-xl-3 col-lg-6">
          <div class="row g-xl-5 g-4 justify-content-center">
            <div class="col-12 d-lg-flex align-items-start">
              <div class="me-xl-4 me-lg-3">
                <div
                  class="icons sec-primary-ic mb-4 d-flex align-items-center justify-content-center mx-auto rounded-pill">
                  <img src={icon2} class="img-fluid" alt="Over a decade of experience" /></div>
              </div>
              <div>
                <p class="">It all begins with a <b class="fw-bold">detailed profiling of your
                    buyer/customer personas</b> by collect and combing data from your existing team
                  combined with our own extensive external research. With this information we can create a
                  <b class="fw-bold">comprehensive profile of your target market</b> and help you
                  identify unique selling propositions.</p>
              </div>
            </div>
            <div class="col-12 d-lg-flex align-items-start">
              <div class="me-xl-4 me-lg-3">
                <div
                  class="icons mb-4 d-flex align-items-center justify-content-center mx-auto sec-primary-ic rounded-pill">
                  <img src={icon4} class="img-fluid" alt="Over a decade of experience" /></div>
              </div>
              <div>
                <p>For over a decade we have provided <b class="fw-bold">expert digital marketing
                    support</b> to develop ideal client profiles and buying patterns - helping you see
                  exactly who you need to be selling to, how you can reach them, and using that
                  information to <b class="fw-bold">deliver a strategic, targeted message</b> designed
                  to get those prospects engaged in a conversation with your business.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-8 col-lg-6 order-lg-3 order-xl-2">
          <div class="about-border right zoom p-0">
            <div class="overflow-hidden">
              <img src={cutout1} alt="" class="border-0" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="bg-light text-center text-lg-start section-padding">
    <div class="container custom-cn-width">
      <div class="row g-lg-5 g-4 justify-content-center">
        <div class="col-xl-6 col-lg-7 col-md-9 pe-xl-5">
          <h1 class="fw-light mb-lg-5 mb-4">CAP Digisoft’s Marketing Consulting team can help with:</h1>
          <div class="row g-lg-5 g-4 justify-content-center">
            <div class="col-12 d-lg-flex align-items-start">
              <div class="me-xl-4 me-lg-3">
                <div
                  class="icons sec-primary-ic mb-4 d-flex align-items-center justify-content-center mx-auto rounded-pill">
                  <img src={icon5} class="img-fluid" alt="Marketing Audit" />
                </div>
              </div>
              <div>
                <h4>Marketing Audit</h4>
                <p class="mt-3">CAP Digisoft <b class="fw-bold">reviews your business and existing sales
                    strategy</b> to identify your specific <b class="fw-bold">strengths and
                    weaknesses.</b> We help you find the areas on which you can improve and put your
                  money to best effect. This includes every aspect of your marketing presence, such as
                  your website, your branding, your collateral, and your messaging.</p>
              </div>
            </div>
            <div class="col-12 d-lg-flex align-items-start">
              <div class="me-xl-4 me-lg-3">
                <div
                  class="icons mb-4 d-flex align-items-center justify-content-center mx-auto sec-primary-ic rounded-pill">
                  <img src={icon6} class="img-fluid" alt="Marketing Audit" /></div>
              </div>
              <div>
                <h4>Marketing Strategy</h4>
                <p class="mt-3">CAP Digsoft’s full-fledged marketing strategy works with you from the ground
                  up to make your business <b class="fw-bold">more visible and your content more
                    engaging.</b> Our team of expert marketing strategists and designers all share a
                  passion for Marketing and a commitment to quality. </p>
              </div>
            </div>
            <div class="col-12 d-lg-flex align-items-start">
              <div class="me-xl-4 me-lg-3">
                <div
                  class="icons mb-4 d-flex align-items-center justify-content-center mx-auto sec-primary-ic rounded-pill">
                  <img src={icon7} class="img-fluid" alt="Marketing Audit" /></div>
              </div>
              <div>
                <h4>Strategy Execution</h4>
                <p class="mt-3">With a comprehensive strategy in place, CAP Digisoft can help you implement
                  that strategy. We pair our <b class="fw-bold">top-tier customer service</b> with
                  detailed <b class="fw-bold">reporting and performance analytics</b> to make sure you
                  stay up-to-date on the effectiveness of your campaigns and your ROI.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-7 col-md-9">
          <div class="about-border right zoom">
            <div class="overflow-hidden border-white border-20">
              <img src={cutout2} alt="CAP Digisoft’s Marketing Consulting team can help with"
                class="border-0 cp-height" />
            </div>
            <div class="about-bg"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="inner-client-sec bg-yellow-1 section-padding">
    <div class="container custom-cn-width">
      <div class="row align-items-center g-5 justify-content-center">
        <div class="col-lg-10">
          <h1 class="fw-400"><i class="fa fa-quote-left me-2"></i>When I was looking out for a creative marketing
            agency, I was truly looking for a partner who can handle inbound and outbound marketing to meet
            every goal that we have set out for our team and that’s exactly what I found. CAP DIGISOFT presented
            us with new ideas that set ourselves apart from our competition. I would strongly recommend CAP
            DIGISOFT Digital marketing for their strategy behind campaigns, SEO program and overall, they are
            great to work with.<i class="fa fa-quote-right ms-2"></i></h1>
          <h4 class="fw-400 mt-4 pt-lg-3">- Marketing Director, M&amp;A Firm</h4>
        </div>
      </div>
    </div>
  </section>
  <section class="section-padding">
    <div class="container custom-cn-width">
      <div class="row g-xl-5 g-4 align-items-center justify-content-center text-center">
        <div class="col-xxl-7 col-xl-8 col-lg-9">
          <h1 class="fw-light mb-lg-4 mb-3">Discover the CAP Digisoft Difference</h1>
          <p class="px-xl-4">Our accomplished and cost-effective client success specialists provide premium solutions,
            empowering you to optimize value and elevate your competitive edge.</p>
        </div>
      </div>
    </div>
  </section>
  <section class="p-0 text-center text-lg-start">
    <div class="container custom-cn-width">
      <div class="cta-block cta-blue b-r-6">
        <div class="row g-lg-5 g-4 align-items-center justify-content-center">
          <div class="col-lg-9">
            <h2 class="fw-light text-white">80% of our marketing audits produce an opportunity to improve ROI. Let CAP
              Digisoft perform an audit of your existing marketing and business strategy today.</h2>
          </div>
          <div class="col-lg-3 text-lg-end">
            <a href="javascript:;" class="default-btn solution_class_popu" data-bs-toggle="modal"
              data-bs-target="#meeting" form_title="Marketing and Consulting Services">Let's Talk</a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="text-center client-block section-padding">
    <div class="container">
      <div class="row g-lg-5 g-4 justify-content-center">
        <div class="col-lg-12 mb-4 mb-lg-5">
          <h1 class="px-lg-4 ">
            Trusted by more than{" "}
            <span class="text-theme fw-bold text-grad">3000+</span> clients
            globally
          </h1>
        </div>
      </div>
      <Slide className="brand-slider" {...properties} slidesToScroll={1} slidesToShow={4} indicators={false}
        autoplay={true}>
        <div class="each-slide-effect">
          <img src={c1} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c2} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c3} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c4} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c5} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c6} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c7} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c8} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c9} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c10} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c11} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c12} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c13} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c14} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c15} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c16} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c17} alt="Logo" class="img-fluid mb-1" />
        </div>

        <div class="each-slide-effect">
          <img src={c19} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c20} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c21} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c22} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c23} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c24} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c25} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c26} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c27} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c28} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c29} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c30} alt="Logo" class="img-fluid mb-1" />
        </div>
        <div class="each-slide-effect">
          <img src={c31} alt="Logo" class="img-fluid mb-1" />
        </div>
      </Slide>
    </div>
  </section>
  <section class="other-sec pt-0 section-padding">
    <div class="container custom-cn-width">
      <div class="row g-5 text-center">
        <div class="col-lg-12 mb-lg-5 mb-4">
          <h1 class="fw-light">Other Solutions</h1>
        </div>
      </div>
      <div class="">
        <div class="row g-4 g-xl-5 text-center text-xl-start">
          <div class="col-lg-4 col-md-6">
            <fieldset class="transition">
              <legend class="text-xl-start">Website Design</legend>
              <div class="d-flex flex-column justify-content-between h-100">
                <h4 class="transition mb-2 mb-lg-3">Comprehensive Website Design</h4>
                <a class="d-inline-block underline-border" href="comprehensive-website-design"><span
                    class="border-line d-inline-block me-1">Learn more</span><i
                    class="fa fa-arrow-right fa-sm position-relative"></i></a>
              </div>
            </fieldset>
          </div>
          <div class="col-lg-4 col-md-6">
            <fieldset class="transition">
              <legend class="text-xl-start">Software</legend>
              <div class="d-flex flex-column justify-content-between h-100">
                <h4 class="transition mb-2 mb-lg-3">Mobile App &amp; Software Development</h4>
                <a class="d-inline-block underline-border" href="mobile-software_development"><span
                    class="border-line d-inline-block me-1">Learn more</span><i
                    class="fa fa-arrow-right fa-sm position-relative"></i></a>
              </div>
            </fieldset>
          </div>
          <div class="col-lg-4 col-md-6">
            <fieldset class="transition">
              <legend class="text-xl-start">KPO</legend>
              <div class="d-flex flex-column justify-content-between h-100">
                <h4 class="transition mb-2 mb-lg-3">Knowledge Process Outsourcing</h4>
                <a class="d-inline-block underline-border" href="knowledge-process-outsourcing"><span
                    class="border-line d-inline-block me-1">Learn more</span><i
                    class="fa fa-arrow-right fa-sm position-relative"></i></a>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </section>
  <FooterOne />
</div>
);
};

export default Products;